import type { ReactNode } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import type { DifficultyLevel } from "./DifficultyBar.utils";
import { MAP_DIFFICULTY_LEVEL_TO_BACKGROUND_COLOR } from "./DifficultyBar.utils";

const DIFFICULTY_BAR_WIDTH_NUMBER = 149;
const DIFFICULTY_BAR_WIDTH_PIXEL = `${DIFFICULTY_BAR_WIDTH_NUMBER}px`;

const DifficultyBarBodyWrapper = styled.div`
    width: ${DIFFICULTY_BAR_WIDTH_PIXEL};
    margin-bottom: 8px;
`;

const DifficultBarIndicator = styled.div`
    height: 8px;
    width: 100%;
    background: ${colorsPalettes.carbon["50"]};
    position: relative;
    z-index: 1;
`;

const VerticalLine = styled.div<{ background: string; $height: string; $width: string }>`
    background: ${({ background }) => background};
    height: ${({ $height }) => $height};
    width: ${({ $width }) => $width};
`;

const DifficultyBarIndicatorFill = styled(DifficultBarIndicator).attrs<{
    "data-automation-difficulty-bar-progress"?: boolean;
}>((props) => ({
    "data-automation-difficulty-bar-progress": true,
}))<{ backgroundColor: string; $width: string }>`
    width: ${({ $width }) => $width};
    background-color: ${({ backgroundColor }) => backgroundColor};
    position: absolute;
    z-index: 2;
`;

const DifficultyBarLegendsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 1px;
`;

const DifficultBarLegendWrapper = styled.div`
    width: 32px;
    justify-content: space-between;
    display: flex;
`;

const LegendsTextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

type DifficultyBarBodyProps = {
    difficultyLevel: DifficultyLevel;
    difficultyGrade: number;
    difficultLabelText: ReactNode;
    easyLevelText: ReactNode;
};

const VERTICAL_LINE_STYLES = {
    $width: "1px",
    $height: "5px",
    background: colorsPalettes.carbon["200"],
};

export const DifficultyBarBody = ({
    difficultyLevel,
    difficultyGrade,
    easyLevelText,
    difficultLabelText,
}: DifficultyBarBodyProps) => {
    const getDifficultyBarIndicatorWidth = () => {
        return `${Math.round((difficultyGrade * DIFFICULTY_BAR_WIDTH_NUMBER) / 100)}px`;
    };
    return (
        <DifficultyBarBodyWrapper>
            <DifficultBarIndicator>
                <DifficultyBarIndicatorFill
                    $width={getDifficultyBarIndicatorWidth()}
                    backgroundColor={MAP_DIFFICULTY_LEVEL_TO_BACKGROUND_COLOR[difficultyLevel]}
                />
            </DifficultBarIndicator>
            <DifficultyBarLegendsWrapper>
                <DifficultBarLegendWrapper>
                    <VerticalLine {...VERTICAL_LINE_STYLES} />
                    <VerticalLine {...VERTICAL_LINE_STYLES} />
                </DifficultBarLegendWrapper>
                <DifficultBarLegendWrapper>
                    <VerticalLine {...VERTICAL_LINE_STYLES} />
                    <VerticalLine {...VERTICAL_LINE_STYLES} />
                </DifficultBarLegendWrapper>
            </DifficultyBarLegendsWrapper>
            <LegendsTextWrapper>
                <div>{easyLevelText}</div>
                <div>{difficultLabelText}</div>
            </LegendsTextWrapper>
        </DifficultyBarBodyWrapper>
    );
};
